class Utilities {
    /**
     * Get all of an element's parent elements up the DOM tree
     *
     * @param {Node} elem
     * @param {String} selector
     * @return {Array}
     */
    static getParents(elem, selector) {
        // Element.matches() polyfill
        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.matchesSelector ||
                Element.prototype.mozMatchesSelector ||
                Element.prototype.msMatchesSelector ||
                Element.prototype.oMatchesSelector ||
                Element.prototype.webkitMatchesSelector ||
                function(s) {
                    let matches = (this.document || this.ownerDocument).querySelectorAll(s);
                    let i = matches.length;

                    while (--i >= 0 && matches.item(i) !== this) {}
                    return i > -1;
                };
        }

        // Setup parents array
        let parents = [];

        // Get matching parent elements
        for (; elem && elem !== document; elem = elem.parentNode) {
            // Add matching parents to array
            if (selector) {
                if (elem.matches(selector)) {
                    parents.push(elem);
                }
            } else {
                parents.push(elem);
            }
        }

        return parents;
    }

    /**
     * Check if an element is visible
     *
     * @param {Node} elem
     * @returns {Boolean}
     */
    static isVisible(elem) {
        return elem.offsetParent !== null;
    }

    /**
     * Generate a GUID v4
     *
     * @returns {String}
     */
    static uuid() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
        );
    }
}

// Export the Utilities module
export default Utilities;
